(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["torras-ss-announcement"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initBar(root){
    if(!root || root.dataset.ssabInit === '1') return;
    root.dataset.ssabInit = '1';
    if(root.getAttribute('data-dismissible') === 'true'){
      var key = root.getAttribute('data-storage-key');
      try{
        if(key && window.localStorage && window.localStorage.getItem(key) === '1'){
          root.hidden = true;
          return;
        }
      }catch(e){}
      var closeBtn = root.querySelector('[data-ssab-close]');
      if(closeBtn){
        closeBtn.addEventListener('click', function(){
          root.hidden = true;
          try{ if(key && window.localStorage){ window.localStorage.setItem(key, '1'); } }catch(e){}
        });
      }
    }
  }
  function boot(){ document.querySelectorAll('[data-torras-ssab]').forEach(initBar); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); }
  else{ boot(); }
  document.addEventListener('shopify:section:load', function(e){
    if(e && e.target){ e.target.querySelectorAll('[data-torras-ssab]').forEach(initBar); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
